export default "__VITE_ASSET__T692JcCX__"